if (!customElements.get('pb-standard-recent')) {
  customElements.define('pb-standard-recent', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.start = () => this.prepare();
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, {once: true});
      else this.prepare();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.start);
      this.observer?.disconnect();
      this.controller?.abort();
    }
    prepare() {
      if (!this.isConnected) return;
      let history = [];
      try {
        if (typeof BtRecentlyViewedUtil !== 'undefined') history = BtRecentlyViewedUtil.getArray();
        else {
          const key = 'pb26_recent_products';
          history = JSON.parse(localStorage.getItem(key) || '[]');
          if (!Array.isArray(history)) history = [];
          const entry = {product_id: this.dataset.productId, url: this.dataset.productUrl};
          localStorage.setItem(key, JSON.stringify([entry, ...history.filter(p => String(p?.product_id) !== this.dataset.productId)].slice(0, 12)));
        }
      } catch { history = []; }
      if (!Array.isArray(history)) return;
      this.ids = [...new Set(history.map(p => String(p?.product_id)).filter(id => /^\d+$/.test(id) && id !== this.dataset.productId))].slice(0, 12);
      if (!this.ids.length) return;
      if (!('IntersectionObserver' in window)) { this.load(); return; }
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, {rootMargin: '500px'});
      this.observer.observe(this);
    }
    async load() {
      const panel = this.querySelector('.pbsr');
      try {
        this.controller = new AbortController();
        const url = new URL(this.dataset.searchUrl, location.origin);
        url.searchParams.set('section_id', 'pb26-standard-recent-items');
        url.searchParams.set('q', this.ids.map(id => `id:${id}`).join(' OR '));
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[unavailable_products]', 'hide');
        const preview = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) throw new Error('History unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = new Map([...doc.querySelectorAll('[data-pbsr-results] > .pbsr-card')].map(card => [card.dataset.productId, card]));
        const grid = this.querySelector('.pbsr-grid');
        const limit = Math.min(6, Math.max(2, Number(this.dataset.limit) || 4));
        const shown = this.ids.map(id => cards.get(id)).filter(Boolean).slice(0, limit);
        for (const card of shown) {
          const link = card.querySelector('a');
          const href = new URL(link.getAttribute('href'), location.origin);
          if (href.origin !== location.origin) continue;
          if (preview) href.searchParams.set('preview_theme_id', preview);
          link.href = href.href;
          grid.appendChild(card);
        }
        panel.hidden = !grid.children.length;
      } catch { panel.hidden = true; }
    }
  });
}
